export default __webpack_public_path__ + "static/media/bg-try-gloow.fdf778e2.svg";